import PropTypes from 'prop-types';
import React, { memo } from 'react';

import Button from '../helpers/Button';
import { AppPage } from '../AppPage';
import { Card } from '../helpers/Card';
import { Spinner } from '../helpers/Spinner';
import { S3FilesTree } from '../S3Files/S3FilesTree';

import style from './style.module.css';

const WindwardComponent = ({
  templates,
  reports,
  isLoading,
  onDelete,
  onUploadClick,
  onRefreshTemplatesClick,
  onRefreshReportsClick,
}) => {
  const toolbar = (
    <div className={style.toolbar}>
      <Button onClick={onUploadClick}>
        <i aria-hidden="true" className="fa fa-cloud-upload" /> Upload
      </Button>
    </div>
  );

  return (
    <AppPage overline="Management" title="Windward" toolbar={toolbar}>
      {isLoading && <Spinner className={style.spinner} />}
      <div className={style.host}>
        <Card
          actions={
            <Button onClick={onRefreshTemplatesClick}>
              <i aria-hidden="true" className="fa fa-refresh" /> Refresh
            </Button>
          }
          className={style.card}
          title="Templates"
        >
          <S3FilesTree data={templates} onDelete={onDelete} />
        </Card>
        <Card
          actions={
            <Button onClick={onRefreshReportsClick}>
              <i aria-hidden="true" className="fa fa-refresh" /> Refresh
            </Button>
          }
          className={style.card}
          title="Reports"
        >
          <S3FilesTree data={reports} onDelete={onDelete} readOnly />
        </Card>
      </div>
    </AppPage>
  );
};

WindwardComponent.propTypes = {
  isLoading: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onRefreshReportsClick: PropTypes.func.isRequired,
  onRefreshTemplatesClick: PropTypes.func.isRequired,
  onUploadClick: PropTypes.func.isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  templates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

/** Windward page: S3 trees of the report templates and the generated reports. */
export const Windward = memo(WindwardComponent);
